import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["name"];
import isArray from 'lodash/isArray';
import getConfig from 'choerodon-ui/es/get-config';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { THEME_EMPTY } from './constants';
import { ThemeContext } from './ThemeContext';
import { dynamicLoadEventEmitter } from './dynamicLoad'; // 从currentTheme中获取某个值

export function getThemeData() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var subField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!props || !props.data || !props.data[field]) {
    return '';
  }
  if (!subField) {
    return props.data[field] || {};
  }
  return props.data[field][subField];
}
var getC7nHzeroStyleLatestTag = function getC7nHzeroStyleLatestTag() {
  if (window._hzero_getC7nHzeroStyleLatestTag !== undefined) {
    return window._hzero_getC7nHzeroStyleLatestTag;
  }
  var eles = document.head.querySelectorAll('link[href*="/packages/choerodon_ui/"],link[href*="/packages/hzero_ui/"],link[href*="/static/css/main."],link[href*="/vendors-"]');
  var finded = eles[eles.length - 1] || null;
  window._hzero_getC7nHzeroStyleLatestTag = finded;
  return finded;
};
/**
 * 获取插入的style标签，没有则创建
 * @param id
 * @returns {HTMLElement}
 */

export function getStyleSheetTarget(id, uiType) {
  var target;
  if (typeof document !== 'undefined') {
    // 支持ssr
    target = document.getElementById(id);
    if (!target) {
      target = document.createElement('style');
      target.id = id;
      var sort;
      if (uiType && (sort = dynamicLoadEventEmitter.sortMap[id]) !== undefined) {
        target.setAttribute('data-ui-type', "".concat(uiType));
        target.setAttribute('data-sort', "".concat(sort));
        var findAfterEle = function findAfterEle() {
          var eles = document.head.querySelectorAll("style[data-ui-type=".concat(uiType, "][data-sort]"));
          var finded = undefined;
          for (var i = 0; i < eles.length; i++) {
            // @ts-ignore
            if (eles[i].getAttribute('data-sort') >= sort) {
              finded = eles[i];
              break;
            }
          }
          if (!finded && eles.length) {
            finded = eles[eles.length - 1].nextSibling;
          }
          return finded;
        };
        try {
          var afterEle = findAfterEle();
          if (afterEle) {
            document.head.insertBefore(target, afterEle);
          } else {
            var c7nHzeroStyleLatestTag = getC7nHzeroStyleLatestTag();
            if (c7nHzeroStyleLatestTag && c7nHzeroStyleLatestTag.nextSibling) {
              document.head.insertBefore(target, c7nHzeroStyleLatestTag.nextSibling);
            } else {
              document.head.appendChild(target);
            }
          }
        } catch (e) {
          console.error(e);
          document.head.appendChild(target);
        }
      } else {
        document.head.appendChild(target);
      }
    }
  }
  return target;
}
/**
 * 依据配置和数据原始数据生成真正的主题数据
 * @param data
 * @param conf
 */

export function resolveTheme(data) {
  var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = arguments.length > 2 ? arguments[2] : undefined;
  if (!Object.keys(data || {}).length) return {};
  var result = {};
  var keys = Object.keys(conf);
  var _ref = opts || {},
    _ref$modifyVars = _ref.modifyVars,
    modifyVars = _ref$modifyVars === void 0 ? {} : _ref$modifyVars,
    _ref$colors = _ref.colors,
    colors = _ref$colors === void 0 ? {} : _ref$colors;
  var resolveModifyVars = data.resolveModifyVars;
  var resolvedModifyVars = typeof resolveModifyVars === 'function' ? resolveModifyVars === null || resolveModifyVars === void 0 ? void 0 : resolveModifyVars({
    colors: colors
  }) : {}; // 合并modifyVars

  Object.keys(resolvedModifyVars).forEach(function (key) {
    if (!modifyVars[key]) {
      modifyVars[key] = {};
    }
    modifyVars[key] = _objectSpread(_objectSpread({}, modifyVars[key]), resolvedModifyVars[key] || {});
  });
  keys.forEach(function (field) {
    if (field === 'schema') return;
    if (!data[field]) {
      return;
    }
    var coverVars = modifyVars[field] || {};
    var currentDataIndex = conf[field];
    var _ref2 = data[field] || {},
      _ref2$data = _ref2.data,
      componentData = _ref2$data === void 0 ? [] : _ref2$data,
      extraTemplate = _ref2.extraTemplate,
      onlyTemplate = _ref2.onlyTemplate,
      global = _ref2.global;
    result[field] = _objectSpread(_objectSpread(_objectSpread({}, componentData[currentDataIndex] || {}), coverVars), {}, {
      __global: global,
      extraTemplate: extraTemplate,
      onlyTemplate: onlyTemplate
    });
  });
  result.__isEmpty__ = data.__isEmpty__;
  result.__uedThemeName__ = data.__uedThemeName__;
  return result;
}
/**
 * 16进制或rgb颜色转rgba
 * @param color {string}
 * @param opacity {number}
 */

export function hexToRgbaColor() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000000';
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (color.indexOf('rgba') > -1) {
    return color;
  } else if (color.indexOf('rgb') > -1) {
    /rgb\((.+)\)/.exec(color);
    return "rgba(".concat(RegExp.$1, ", ").concat(opacity, ")");
  }
  var hex = color.slice(1);
  if (hex.length !== 3 && hex.length !== 6) {
    return 'rgba(0, 0, 0, 0)';
  }
  if (hex.length === 3) {
    return "rgba(".concat(parseInt(hex.slice(0, 1), 16), ", ").concat(parseInt(hex.slice(1, 2), 16), ", ").concat(parseInt(hex.slice(2, 3), 16), ", ").concat(opacity, ")");
  }
  var r = parseInt("0x".concat(hex.slice(0, 2)), 16);
  var g = parseInt("0x".concat(hex.slice(2, 4)), 16);
  var b = parseInt("0x".concat(hex.slice(4)), 16);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
}
/**
 * 对外提供的工具函数，用于获取静态资源图片url
 * @param name
 * @returns {string|undefined}
 */

export function getAsset(name) {
  var _ref3 = (ThemeContext || {})._currentValue || {},
    _ref3$resolvedTheme = _ref3.resolvedTheme,
    resolvedTheme = _ref3$resolvedTheme === void 0 ? {} : _ref3$resolvedTheme;
  var _resolvedTheme$images = resolvedTheme.images,
    assets = _resolvedTheme$images === void 0 ? {} : _resolvedTheme$images;
  return assets[name];
}
export function isEmpty(schema, theme) {
  return schema === THEME_EMPTY || (theme === null || theme === void 0 ? void 0 : theme.__isEmpty__);
}

/**
 * 根据组件数据创建一个themeData
 * @param dataList
 */
export function createThemeData(dataList, opts) {
  var result = {};
  dataList.forEach(function (_ref4) {
    var name = _ref4.name,
      rest = _objectWithoutProperties(_ref4, _excluded);
    result[name] = _objectSpread({
      name: name
    }, rest);
  });
  result.resolveModifyVars = opts === null || opts === void 0 ? void 0 : opts.resolveModifyVars;
  result.__isEmpty__ = opts === null || opts === void 0 ? void 0 : opts.__isEmpty__;
  result.__uedThemeName__ = opts === null || opts === void 0 ? void 0 : opts.__uedThemeName__;
  return result;
}
export function getDefaultConfig(data) {
  return Object.keys(data).filter(function (k) {
    var _ref5;
    return isArray((_ref5 = data[k]) === null || _ref5 === void 0 ? void 0 : _ref5.data);
  }).reduce(function (prev, key) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, 0));
  }, {});
}
/**
 * 创建局部样式数据
 * @param dataList 数据列表
 * @returns ObjectType
 */

export function createPartialData(dataList) {
  var configData = createThemeData(dataList);
  var defaultConfig = getDefaultConfig(configData);
  return resolveTheme(configData, defaultConfig);
}
export function defineGlobalVersion(pkg) {
  if (pkg && typeof window !== 'undefined') {
    var g = window;
    var key = '__UED_VERSION__';
    if (!g[key]) {
      g[key] = {};
    }
    var _pkg$name = pkg.name,
      name = _pkg$name === void 0 ? '' : _pkg$name,
      _pkg$version = pkg.version,
      version = _pkg$version === void 0 ? '' : _pkg$version;
    g[key][name] = version;
  }
}
export function getPrimaryColor() {
  if (!ThemeContext || !ThemeContext._currentValue) {
    return '';
  }
  var contextValue = ThemeContext._currentValue.originTheme || {};
  var common = contextValue.common || {};
  return common.primary;
}
export var getC7NContextConfig = function getC7NContextConfig(key) {
  if (ConfigContext && ConfigContext._currentValue) {
    var _ref6 = ConfigContext._currentValue || {},
      getConfigAlias = _ref6.getConfig;
    return getConfigAlias ? getConfigAlias(key) : getConfig(key);
  }
  return getConfig(key);
};